import React from 'react';
export function PainPointsSection() {
  const pains = [{
    icon: '❓',
    text: 'No sabes qué plantar'
  }, {
    icon: '💧',
    text: 'No entiendes el riego o la luz'
  }, {
    icon: '🥀',
    text: 'Se te mueren las plantas sin saber por qué'
  }, {
    icon: '🔄',
    text: 'Probaste varias veces sin resultados'
  }, {
    icon: '🚫',
    text: 'Terminaste abandonando'
  }];
  return <section className="relative bg-neutral-bg py-12 px-4 sm:px-6 lg:px-8 border-y border-neutral-beige" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <div className="text-center mb-10" data-id="element-82">
          <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A] mb-3" data-id="element-83">
            Tener una huerta no debería sentirse así
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-84">
            No fallas porque no puedas… fallas porque no tienes un sistema.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 sm:gap-6 mb-10" data-id="element-85">
          {pains.map((pain, i) => <div key={i} className="bg-white rounded-2xl p-5 text-center shadow-md hover:shadow-xl transition-all duration-300 border border-transparent hover:border-earth-light/50 group transform hover:-translate-y-1" data-id="element-86">
              <div className="text-4xl mb-3 transform group-hover:scale-110 transition-transform duration-300" data-id="element-87">
                {pain.icon}
              </div>
              <p className="text-sm sm:text-base font-bold text-gray-800 leading-snug" data-id="element-88">
                {pain.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-89">
          <p className="font-serif text-xl sm:text-2xl font-black text-garden-dark bg-white px-8 py-4 rounded-2xl shadow-lg inline-block mx-auto border border-garden-bg relative overflow-hidden" data-id="element-90">
            <span className="absolute top-0 left-0 w-full h-1 bg-gradient-garden" data-id="element-91"></span>
            👉 "No logro hacer algo simple funcionar"
          </p>
        </div>
      </div>
    </section>;
}